/**
This tooltip module is designed to work only .lendingtree.com domain. For other domain, please disable the same.
*/
<template>
    <span>
        <a
            :class="contactBtnClass"
            :target="target"
            @click="handleClick($event)">{{ contactBtnText }}</a>
        <div class="successAutoSubmit">Success!</div>
        <!-- use the modal component, pass in the prop -->
        <modal
            v-if="ShowModal"
            class="lender-contact-modal"
            @close="clearModalData()">
            <div slot="body">
                <contact-form
                    v-if="ShowContactForm"
                    :lender-name="lenderName"
                    :loan-term="loanTerm"
                    :loan-type="loanType"
                    :rate="rate"
                    :fees="fees"
                    :contact-number="contactNumber"
                    :contact-btn-class="contactBtnClass"
                    :contact-btn-text="contactBtnText"
                    :offer-id="offerId"
                    :lender-id="lenderId"
                    :quotes-id="quotesId"
                    :apr="apr"
                    :loan-amount="loanAmount"
                    :if-modal="IfModal"
                    :show-phone-numbers="ShowPhoneNumbers"
                    :vertical="vertical"
                    :placement="placement"
                    :lending-entity-id="lendingEntityId"
                    :variation-name="variationName"
                    :is-phone-indicator="isPhoneIndicator"
                    :el-clicked="elClicked"
                    :first-name="firstName"
                    :last-name="lastName"
                    :email="email"
                    :phone="phone"
                    :context="context"
                    @closeModal="handleClearModal"
                />
                <thank-you-popup v-if="!ShowContactForm" />
            </div>
        </modal>
    </span>
</template>

<script>
    import { isNullOrUndefined } from '~/helpers/util';
    import Modal from './modal.vue';
    import ContactForm from './preprime-contact-form.vue';
    import AnalyticsTrack from '~/mixin/analytics-track';
    import trackData from '~/mixin/track-data';
    import ThankYouPopup from './thank-you-popup.vue';
    import submitLeadDetails from '~/mixin/preprime-submit-lead-details';

    export default {
        components: {
            Modal,
            ContactForm,
            ThankYouPopup,
        },
        mixins: [AnalyticsTrack, trackData, submitLeadDetails],
        props: {
            loanTerm: {
                default: '',
            },
            loanType: {
                default: '',
            },
            rate: {
                default: 0,
            },
            fees: {
                default: 0,
            },
            contactBtnClass: {
                default: 'btn btn-orange',
            },
            contactBtnText: {
                default: 'Contact',
            },
            showPhoneNumbers: {
                default: true,
            },
            placement: {
                default: '',
            },
            vertical: {
                default: '',
            },
            variationName: {
                default: '',
            },
            isPhoneIndicator: {
                default: true,
            },
            context: {
                default: 'www',
            },
        },
        data() {
            return {
                target: '',
                ShowModal: false,
                ModalBody: '',
                IfModal: true,
                ShowPhoneNumbers: this.showPhoneNumbers,
                LoanType: this.loanType,
                ShowContactForm: true,
                elClicked: '',
            };
        },
        methods: {
            handleClick(event) {
                this.elClicked = event.target;
                if (this.checkIsNullOrEmpty(this.firstName) && this.checkIsNullOrEmpty(this.email) && this.checkIsNullOrEmpty(this.phone)) {
                    this.ShowModal = false;
                    // UI confirmation
                    event.target.nextElementSibling.style.display = 'block';
                    event.target.classList.add('green-circle');
                    event.target.innerHTML = '<div class="lt4-Check"></div>';

                    this.submitLeadDetails();
                } else {
                    this.ShowModal = true;
                    this.elClicked = event.target;
                    this.ShowContactForm = true;
                }
                return false;
            },
            clearModalData() {
                this.ShowModal = false;
            },
            handleClearModal() {
                if (this.lenderName !== 'Ovation Credit') this.ShowModal = false;
                else this.ShowContactForm = false;
            },
            checkIsNullOrEmpty(value) {
                return !isNullOrUndefined(value) && value.length > 0;
            },
        },
    };
</script>

<style lang="scss">
@import "../../assets/styles/variables";

#lt-yantr {
    .lender-contact-modal {
        text-align: left;

        .modal-wrapper {
            max-width: 500px;
        }

        .title {
            span {
                font-size: 13px;
                font-weight: 600;
                display: block;
            }
        }
        .contact-form {
            li {
                margin-bottom: 10px;

                &.loan-term {
                    color: #08c177;
                    font-size: 17px;
                    font-weight: 600;
                }

                input {
                    margin-bottom: 5px;
                }

                .btn {
                    display: inline-block;
                    margin-top: 5px;
                    float: none;
                    display: inline-block;
                    width: auto;

                    @media #{$mob-portrait-view} {
                        width: 100%;
                    }

                    &.green-circle-popup {
                        background: #08c177;
                        margin: 0;
                        padding: 0;
                        border-radius: 50%;
                        width: 30px;
                        height: 30px;
                        min-width: 30px;
                        min-height: 30px;
                    }

                    &.btn:disabled {
                        animation: none;
                        opacity: .7;
                        cursor: not-allowed;
                        pointer-events: none;
                        float: none;
                        display: inline-block;
                        width: auto;

                        @media #{$mob-portrait-view} {
                            width: 100%;
                        }
                    }
                }

                .cell-no {
                    color: #101f30;
                    font-size: 20px;
                    font-weight: 300;
                    display: inline-block;
                    float: right;

                    @media #{$mob-portrait-view} {
                        text-align: center;
                        display: block;
                        float: none;
                    }
                }

                span {
                    color: #e10000;
                }
            }
            li:last-child {
                display: flex;
                justify-content: space-between;
                align-items: center;
                @media (max-width: 767px) {
                    flex-direction: column;
                }
                button.success {
                    background: #08c177;
                    margin: 0;
                    padding: 0;
                    border-radius: 50%;
                    min-width: 30px;
                    min-height: 30px;
                }
            }
        }

        .legalize-text {
            padding: 10px 0 0;
            clear: both;

            p {
                font-size: 13px;
                line-height: normal;
                color: #999;
                margin-bottom: 0;

                &:first-child {
                    margin-bottom: 1em;
                }

                a {
                    color: #999;
                }
            }
        }
    }
    .successSubmit,
    .successAutoSubmit {
        display: none;
        color: #08c177;
        font-weight: 600;
        flex: 1;
        @media (max-width: 767px) {
            margin-left: 0;
        }
    }
    .successSubmit {
        margin-left: 20px;
        @media (max-width: 767px) {
            margin-left: 0;
        }
    }
}
</style>
